import {
  BedDouble,
  Camera,
  Clapperboard,
  MapPin,
  Music,
  UtensilsCrossed,
  Waves,
  type LucideIcon,
} from "lucide-react";
import type { ActivityCategory } from "@travelix/core";

export interface ActivityCategoryMeta {
  id: ActivityCategory;
  label: string;
  icon: LucideIcon;
  /** Fully-opaque accent color for the icon glyph. */
  color: string;
  /** Low-alpha version of `color` for the soft badge background. */
  softColor: string;
}

// Distinct hues so the timeline reads at a glance. Kept as inline hex so
// no design-system variables need adding for this first pass; if we ever
// want theme-aware categories we can promote these to CSS variables.
export const ACTIVITY_CATEGORIES: readonly ActivityCategoryMeta[] = [
  { id: "stay",    label: "Stay",    icon: BedDouble,        color: "#14b8a6", softColor: "rgba(20,184,166,0.16)" },
  { id: "place",   label: "Place",   icon: MapPin,           color: "#8b5cf6", softColor: "rgba(139,92,246,0.16)" },
  { id: "food",    label: "Food",    icon: UtensilsCrossed,  color: "#f59e0b", softColor: "rgba(245,158,11,0.18)" },
  { id: "concert", label: "Concert", icon: Music,            color: "#ec4899", softColor: "rgba(236,72,153,0.16)" },
  { id: "movie",   label: "Movie",   icon: Clapperboard,     color: "#6366f1", softColor: "rgba(99,102,241,0.16)" },
  { id: "beach",   label: "Beach",   icon: Waves,            color: "#06b6d4", softColor: "rgba(6,182,212,0.18)" },
  { id: "photo",   label: "Photo",   icon: Camera,           color: "#10b981", softColor: "rgba(16,185,129,0.16)" },
];

const CATEGORY_BY_ID = new Map<ActivityCategory, ActivityCategoryMeta>(
  ACTIVITY_CATEGORIES.map((c) => [c.id, c]),
);

export function getCategoryMeta(id: ActivityCategory | null | undefined): ActivityCategoryMeta | null {
  if (!id) return null;
  return CATEGORY_BY_ID.get(id) ?? null;
}
